module.exports = __webpack_public_path__ + "static/media/ROsanswebtextregular.c94619b6.ttf";